import React from 'react';
import { View, Svg, Line, Circle, Text, Path } from '@react-pdf/renderer';
import type { Goal } from '../types';

interface ShotPositionDiagramPDFProps {
  goals: Goal[];
  width?: number;
  height?: number;
}

const ShotPositionDiagramPDF: React.FC<ShotPositionDiagramPDFProps> = ({ 
  goals,
  width = 200,
  height = 150
}) => {
  return (
    <View style={{ width, height }}>
      <Svg viewBox="0 0 100 100" width={width} height={height}>
        {/* Blue line at the top */}
        <Line x1={0} y1={0} x2={100} y2={0} stroke="#00A3E0" strokeWidth={2} />

        {/* Rink outline */}
        <Path
          d="M 0 0 L 0 80 Q 0 100 20 100 L 80 100 Q 100 100 100 80 L 100 0"
          stroke="#000000"
          strokeWidth={1}
          fill="none"
        />

        {/* Center ice semi-circle */}
        <Path
          d="M 40 100 A 10 10 0 0 1 60 100"
          stroke="#00A3E0"
          strokeWidth={1}
          fill="#00A3E0"
          fillOpacity={0.1}
        />

        {/* Grid lines */}
        <Line x1={33.33} y1={0} x2={33.33} y2={100} stroke="#E5E7EB" strokeWidth={0.5} />
        <Line x1={66.66} y1={0} x2={66.66} y2={100} stroke="#E5E7EB" strokeWidth={0.5} />
        <Line x1={0} y1={33.33} x2={100} y2={33.33} stroke="#E5E7EB" strokeWidth={0.5} />
        <Line x1={0} y1={66.66} x2={100} y2={66.66} stroke="#E5E7EB" strokeWidth={0.5} />

        {/* Shot positions */}
        {goals.map((goal, index) => {
          if (!goal.shotXPosition || !goal.shotYPosition) return null;
          return (
            <React.Fragment key={goal.id}>
              <Circle
                cx={goal.shotXPosition}
                cy={goal.shotYPosition}
                r={1.5}
                fill="#ef4444"
              />
              <Text
                x={goal.shotXPosition + 2}
                y={goal.shotYPosition - 2}
                style={{
                  fontSize: 8,
                  fill: '#374151'
                }}
              >
                {index + 1}
              </Text>
            </React.Fragment>
          );
        })}
      </Svg>
    </View>
  );
};

export default ShotPositionDiagramPDF;